<template>
  <Form
    class="newsletter-form"
    :form-fields="formFields"
    :form-error="formError"
    :is-loading="isLoading"
    @submit="submit"
  />
</template>

<script lang="ts" setup>
import type {
  PublicSubscribeRequest,
  PublicNewsletterSettings,
  PublicNewsletterAgreement
} from '@/service/__generated-api'

const { t } = useI18n()

const props = defineProps<{
  settings: PublicNewsletterSettings
  widgetId?: string
}>()

const { formError, setFormError } = useFormNonFieldError()
const isLoading = ref(false)

const formFields = [
  {
    label: t('newsletter.your-name.label'),
    name: 'first_name',
    rules: 'required',
    placeholder: t('newsletter.your-name.placeholder'),
    type: 'text'
  },
  {
    label: t('newsletter.your-email.label'),
    name: 'email',
    rules: 'required|email',
    placeholder: t('newsletter.your-email.placeholder'),
    type: 'text'
  }
]

const addAgreementsFromSettings = (agreement: PublicNewsletterAgreement) => {
  formFields.push({
    label: agreement.text,
    name: 'agreement',
    rules: agreement.is_required ? 'required' : '',
    type: 'checkbox',
    placeholder: ''
  })
}

props.settings.agreement && addAgreementsFromSettings(props.settings.agreement)

const emit = defineEmits(['success'])

const submit = async (formData: PublicSubscribeRequest) => {
  isLoading.value = true
  const payload = {
    ...formData,
    ...(props?.widgetId && { widget: props.widgetId })
  }
  try {
    await useApi().publicNewsletterSubscribeCreate(payload)
    emit('success')
  } catch (error) {
    setFormError(error)
  } finally {
    isLoading.value = false
  }
}
</script>

<style lang="scss" scoped>
.newsletter-form {
  :deep(.text-input) {
    margin-bottom: rem(28px);
  }

  :deep(.button-wrap) {
    margin-top: rem(28px);

    &:has(.rule-text) {
      margin-top: rem(9px);
    }
  }
}
</style>
